/** 약관 페이지 타입 */
export type TermsPageType = 'privacy' | 'cookie' | 'term';

/** 약관 페이지 타입인지 확인 */
export const isTermsPageType = (termType: any): termType is TermsPageType => {
  return ['privacy', 'cookie', 'term'].includes(termType);
};
